<ng-template #eyeOpen>
  <svg
    class="w-6 h-6 hover:text-blue-500 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
    />
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
</ng-template>
<ng-template #eyeSlash>
  <svg
    class="w-6 h-6 hover:text-blue-500 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
</ng-template>
<ng-template #checkCircle>
  <svg
    class="w-4 h-4 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
</ng-template>
<ng-template #checkFilledCircle>
  <svg
    class="w-4 h-4 text-green-600 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
      clip-rule="evenodd"
    />
  </svg>
</ng-template>

<section class="bg-gray-50 dark:bg-gray-900">
  @if (loading) {
    <div class="text-gray-600 dark:text-gray-300 text-center">
      Verifying your reset link...
    </div>
  }
  @if (!loading && isValidToken) {
    <div
      class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
    >
      <a
        href="#"
        class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
      >
        @if (themeSerivice.darkMode$ | async) {
          <img
            src="/assets/svg/LIQ_DDA_dark.svg"
            class="h-8"
            alt="Flowbite Logo"
          />
        } @else {
          <img
            src="/assets/svg/LIQ_DDA_white.svg"
            class="h-8"
            alt="Flowbite Logo"
          />
        }
      </a>
      <div
        class="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8"
      >
        <h2
          class="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
        >
          Change Password
        </h2>
        @if (errorMessage) {
          <div
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
            role="alert"
          >
            <h3 class="font-bold">
              Please correct the errors below and try again
            </h3>
            <p>{{ errorMessage }}</p>
          </div>
        }
        <form
          class="mt-4 flex flex-col gap-2 lg:mt-5 md:gap-3"
          [formGroup]="resetForm"
          (ngSubmit)="resetPassword()"
        >
          <div>
            <label
              for="newPassword"
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >New Password</label
            >
            <div class="relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                name="newPassword"
                id="newPassword"
                placeholder="••••••••"
                formControlName="newPassword"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 pe-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    passwordControl?.invalid &&
                    (passwordControl?.dirty || passwordControl?.touched),

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    !(
                      passwordControl?.invalid &&
                      (passwordControl?.dirty || passwordControl?.touched)
                    ),
                }"
              />
              <button
                type="button"
                [title]="showPassword ? 'Hide password' : 'Show password'"
                class="absolute right-2 inset-y-0"
                (click)="showPassword = !showPassword"
              >
                <ng-container
                  [ngTemplateOutlet]="showPassword ? eyeOpen : eyeSlash"
                />
              </button>
            </div>
            <ul class="ps-1 mt-2">
              @for (criterion of passwordCriteria; track criterion.at(0)) {
                <li
                  *ngIf="criterion.at(0) !== undefined"
                  class="text-sm"
                  [ngClass]="{
                    'text-green-800':
                      resetForm.get('newPassword')?.hasError(criterion[0]) ===
                        false && resetForm.get('newPassword')?.value.length > 0,
                    'text-gray-500':
                      resetForm.get('newPassword')?.hasError(criterion[0]) ===
                        true ||
                      resetForm.get('newPassword')?.value.length === 0,
                  }"
                >
                  <div class="flex flex-row gap-2 items-center">
                    <ng-container
                      [ngTemplateOutlet]="
                        (
                          resetForm
                            .get('newPassword')
                            ?.hasError(criterion[0]) === false &&
                          resetForm.get('newPassword')?.value.length > 0
                        ) ?
                          checkFilledCircle
                        : checkCircle
                      "
                    />
                    {{ criterion.at(1) }}
                  </div>
                </li>
              }
            </ul>
          </div>
          <div>
            <label
              for="confirmedPassword"
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Confirm password</label
            >
            <div class="relative">
              <input
                [type]="showConfirmedPassword ? 'text' : 'password'"
                name="confirmedPassword"
                id="confirmedPassword"
                placeholder="••••••••"
                formControlName="confirmedPassword"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 pe-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    getInputErrorMessage('confirmedPassword') !== null,

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    getInputErrorMessage('confirmedPassword') === null,
                }"
              />
              <button
                type="button"
                [title]="
                  showConfirmedPassword ? 'Hide password' : 'Show password'
                "
                class="absolute right-2 inset-y-0"
                (click)="showConfirmedPassword = !showConfirmedPassword"
              >
                <ng-container
                  [ngTemplateOutlet]="
                    showConfirmedPassword ? eyeOpen : eyeSlash
                  "
                />
              </button>
            </div>
            <div
              class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
              [ngClass]="{
                invisible: getInputErrorMessage('confirmedPassword') === null,
              }"
            >
              {{ getInputErrorMessage("confirmedPassword") }}
            </div>
          </div>
          <button
            class="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            type="submit"
          >
            Reset password
          </button>
        </form>
      </div>
    </div>
  }
</section>
